<template>
  <div
    id="footer-con"
    class="footer-con border-top d-flex bg-secondary p-3"
    :style="{ zIndex }"
  >
    <b-button
      v-if="showBackButton"
      :disabled="lastDisabled"
      @click="navigate('last')"
      size="md"
      variant="secondary"
      :class="{ 'btn-loading': isLoading }"
    >
      <i class="fas fa-arrow-left mr-2" />
      Back
    </b-button>
    <b-button
      :disabled="nextDisabled"
      @click="navigate('next')"
      size="md"
      variant="primary"
      data-test="submit-button"
      class="ml-auto"
      :class="{ 'btn-loading': isLoading }"
    >
      {{ nextText }}
      <i
        v-if="nextIcon"
        class="fas fa-arrow-right ml-2"
      />
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'BaseWizardFooter',
  components: {
  },
  props: {
    nextDisabled: {
      type: Boolean,
      default: false,
    },
    nextText: {
      type: String,
      default: 'Next',
    },
    nextVariant: {
      type: String,
      default: 'sm-primary',
    },
    nextIcon: {
      type: Boolean,
      default: true,
    },
    lastDisabled: {
      type: Boolean,
      default: false,
    },
    lastStep: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 100,
    },
  },
  computed: {
  },
  methods: {
    navigate(type) {
      if (type === 'last') {
        if (!this.lastDisabled) this.$emit('previous-step');
      } else if (type === 'next') {
        if (!this.nextDisabled) this.$emit('next-step');
      }
    },
  },
};
</script>
<style>

</style>
